"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const WidgetIframe = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, x: 2, y: 2, fill: "#1099FC", rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M14.127 6.044a.75.75 0 01.454.958l-3.75 10.5a.75.75 0 01-1.412-.504l3.75-10.5a.75.75 0 01.958-.454z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillOpacity: 0.75,
        fillRule: "evenodd",
        d: "M8.155 9.905a.75.75 0 00-1.06-1.06L4.47 11.47a.75.75 0 000 1.06l2.625 2.625a.75.75 0 001.06-1.06L6.061 12l2.094-2.095zm7.69 0a.75.75 0 011.06-1.06l2.625 2.625a.75.75 0 010 1.06l-2.625 2.625a.75.75 0 11-1.06-1.06L17.939 12l-2.094-2.095z"
      }
    )
  );
};
export default WidgetIframe;
